import { render, staticRenderFns } from "./DepartmentPositionSelection.vue?vue&type=template&id=551cb0f8&"
import script from "./DepartmentPositionSelection.vue?vue&type=script&lang=ts&"
export * from "./DepartmentPositionSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports